"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SIASearch = require("./SIASearch");
var _reactRouterDom = require("react-router-dom");
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--right/24.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MAX_DESCRIPTION = 225;
const ArticlesResults = _ref => {
  let {
    text,
    articles,
    lang,
    translate
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "articles sia-margin-02-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-03  sia-margin-03-bottom"
  }, translate('cms.search.articles')), articles.map(el => {
    const title = (0, _SIASearch.setHighlightText)(el.title, text);
    const lead = el.article_lead;
    const isLongDescription = lead?.length > MAX_DESCRIPTION;
    const description = (0, _SIASearch.setHighlightText)(`${lead?.length > 0 ? lead?.slice(0, MAX_DESCRIPTION)?.trim() : ''}${isLongDescription ? '...' : ''}`, text);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "sia-border-01-bottom sia-padding-03-bottom sia-margin-03-bottom",
      key: title
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "sia-text-12",
      dangerouslySetInnerHTML: {
        __html: title
      }
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "sia-text-10 sia-margin-02-top",
      dangerouslySetInnerHTML: {
        __html: description
      }
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "sia-text-06 sia-margin-02-top  sia-margin-03-bottom"
    }, (0, _SIASearch.formatDate)(el.date)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      className: "link",
      to: `/${lang}/cms${el.alias}`
    }, /*#__PURE__*/_react.default.createElement(_.default, {
      className: "page-action-down-32"
    })));
  }));
};
var _default = exports.default = ArticlesResults;